<template>
    <s-modal 
        :open="open"
        :title="'Visibilité du club : '+club.name"
        :close="true"
        :save="!club.demo"
        @save="saveCode"
        @close="$emit('close')"
                >
        <div  v-if="club.demo">
            <s-l id="clubdemo_notvisible">En mode démo, vous ne pouvez pas rendre visible votre club</s-l>
        </div>

        <div style="height: 450px;position: relative" v-if="!club.demo">
        <div class="explainPublic">
        <s-l id="explain_clubPublic">En rendant votre club visible, vous permettez à n'importe quel utilisateur de rechercher et de visualiser votre club.<br/>Il pourra ainsi voir le nom du président, l'adresse du club, le numéro de téléphone...<br/></s-l>
        </div>
        <div style="text-align:center">
            Visible :
            <s-switch 
                    labelEnableText="OUI" 
                    labelDisableText="NON" id="public" 
                    @change="setPublic" 
                    :defaultState="club.public ? true : false"/>
       
        </div>
        <div v-show="club.public">
            <hr/>
            <div  class="title is-5">
                <s-l id="explain_clubPublic">Votre site est désormais accessible depuis la recherche de club</s-l>
            </div>
            <div  class="labelParameter">
                <s-l id="explain_clubPublicCode">Les concours et les saisons sont accessibles par un code pin à 4 chiffres :</s-l>
            </div>
            <div   class="inputCode">
            <PincodeInput
                    v-model="code"
                    placeholder="0"
            />
            <div class='labelParameter'>
                <br/>
                Donnez la possibilité aux visiteurs d'effectuer une demande d'adhésion à votre club :
                <br/>
                <s-switch 
                    labelEnableText="OUI" 
                    labelDisableText="NON" id="adhesion" 
                    @change="setAdhesion" 
                    :defaultState="club.adhesion ? true : false"/>
            </div>

        </div>
            </div>
            <div v-show="!club.public" class="title is-5"><br/>
                <s-l id="explain_clubNotPublic">Votre site n'est pas accessible depuis la recherche de club</s-l>
            </div>
        
        

        </div>
    </s-modal>
</template>
<style scoped>
    .title {
        text-align:center;
    }
    .labelParameter {
        font-size: 14px;
        color: black;
        font-weight: bolder;
        text-align:center;
    }
    .explainPublic {
        font-size: 15px;
        color: black;
        text-align: left;
    }
     .inputCode {
        margin-left: auto;
        margin-right: auto;
        margin-top: 10px;
        text-align: center;
    }
</style>
<script>
import firebase_api from '@/firebase/firebase_api'
export default {
    props: ["open","club"],
    data() {
        return {
             code: "0000"
        }
    },
    watch: {
        open: function() {
            if (this.open)
                this.refreshCode();
        }
    },
    methods: {
        getRandomInt(max) {
        return Math.floor(Math.random() * max);
        },
        async refreshCode() {
           
            var id = this.club.id;
            
            var codeDoc = await firebase_api.api.getDb().collection("club").doc(id)
                .collection("code").doc("code").get();
           
            if (codeDoc.exists) {
                var code = codeDoc.data().code;
                if (Array.isArray(code)) {
                    this.code ="";
                    for (var i=0;i<4;i++) {
                        var number = this.getRandomInt(9);
                        this.code = number.toString() + this.code;
                    }
                }
                else    
                    this.code = code;
            }
            else {
                
                this.code ="";
                    for (var i=0;i<4;i++) {
                        var number = this.getRandomInt(9);
                        this.code = number.toString() + this.code;
                    }
                if (typeof(this.club.id)!="undefined")
                    this.saveCode(false);
            }
        },
         setPublic(bool) {
             console.log("setPublic")
             console.log(bool)
            if (typeof(this.club.public)!="undefined")
                this.club.public = bool;
            else
                this.club.public = bool;
           
        },
        setAdhesion(bool) {
            console.log("setAdhesion")
            this.club.adhesion = bool;
        },
         saveCode(closeModal) {
             
             if (typeof(this.club.adhesion)=="undefined")
                this.club.adhesion = false;
            
             firebase_api.api.getDb().collection("club").doc(this.club.id).update({
                public: this.club.public,
                adhesion: this.club.adhesion
            }).then(()=>{
                firebase_api.api.getDb().collection("club").doc(this.club.id)
                    .collection("code").doc("code").set({
                        code: this.code
                    }).then(()=>{
                        if (typeof(closeModal)=="undefined")
                            this.$emit('close');
                        else if (closeModal)
                            this.$emit('close');
                                
                    })
            })
        },
    }
}
</script>